import { localStorageOrDefault, cacheInLocalStorage } from "../utils";
import { CompactAction, SET_COMPACT, State } from "./types";

const initial = localStorageOrDefault('menu', { compact: false })

function menu(state: State = initial, action: CompactAction): State {
  return {
    [SET_COMPACT]: {
      ...state,
      compact: action.payload
    }
  }[action.type] || state;
}

export default cacheInLocalStorage(menu);